export const stageData = [
    {
        level: 1,
        time: 40,
        colSet: 4,
        rowSet: 6,
        imgSet: 6
    },
    {
        level: 2,
        time: 48,
        colSet: 6,
        rowSet: 6,
        imgSet: 9
    },
    {
        level: 3,
        time: 53,
        colSet: 5,
        rowSet: 8,
        imgSet: 10
    },
    {
        level: 4,
        time: 64,
        colSet: 6,
        rowSet: 8,
        imgSet: 12
    },
    {
        level: 5,
        time: 80,
        colSet: 6,
        rowSet: 10,
        imgSet: 15
    },
    {
        level: 6,
        time: 106,
        colSet: 8,
        rowSet: 10,
        imgSet: 20
    },
    {
        level: 7,
        time: 112,
        colSet: 7,
        rowSet: 12,
        imgSet: 21
    },
    {
        level: 8,
        time: 128,
        colSet: 8,
        rowSet: 12,
        imgSet: 24
    },
]